import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';

import { ContractTypeService } from '../proxy/controlling/controllers/contract-type.service';
FieldBuilder.setNamespace('Controlling');

export const CONTRACTTYPEMGSPARAMETER_FIELDS: FieldDefinition[] = [
  FieldBuilder.foreignKey('contractTypeId', 'Entity.ContractType', ContractTypeService)
    .displayFromNested('contractType.name')
    .sortBy('contractType.name')
    .hideInChildForms()
    .build(),
  FieldBuilder.text('sign', 'Entity.ContractTypeMgsParameter.Sign')
    .build(),
  FieldBuilder.text('articleFilter', 'Entity.ContractTypeMgsParameter.ArticleFilter')
    .build(),
  FieldBuilder.text('mgsCode', 'Entity.ContractTypeMgsParameter.MgsCode')
    .build(),
  FieldBuilder.checkbox('isActivityReportImported', 'Entity.ContractTypeMgsParameter.IsActivityReportImported')
    .build(),
  FieldBuilder.checkbox('isInventoryControlled', 'Entity.ContractTypeMgsParameter.IsInventoryControlled')
    .build(),
  FieldBuilder.checkbox('isGenericServiceOrder', 'Entity.ContractTypeMgsParameter.IsGenericServiceOrder')
    .build(),
  FieldBuilder.checkbox('isStandingStockImpacted', 'Entity.ContractTypeMgsParameter.IsStandingStockImpacted')
    .build(),
  FieldBuilder.checkbox('isContractTypeActive', 'Entity.ContractTypeMgsParameter.IsContractTypeActive')
    .build(),
  FieldBuilder.checkbox('isOriginControl', 'Entity.ContractTypeMgsParameter.IsOriginControl')
    .build(),
  FieldBuilder.text('owner', 'Entity.ContractTypeMgsParameter.Owner')
    .build(),
  FieldBuilder.checkbox('validityControl', 'Entity.ContractTypeMgsParameter.ValidityControl')
    .build(),
];

export const CONTRACTTYPEMGSPARAMETER_CONFIG = {
  entityName: 'ContractTypeMgsParameter',
  localizationKey: 'Controlling::Entity.ContractTypeMgsParameter',
  fields: CONTRACTTYPEMGSPARAMETER_FIELDS,
  permission: 'Controlling.ContractTypeMgsParameters',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Controlling + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.Contracts + MENU_NAME_SUFFIX,
};
